import React, { useContext } from 'react'
import styled, { css } from 'styled-components'
import media from 'css-in-js-media'

import AccordionContext from './AccordionContext'
import Toggle, { ToggleWrap } from './Toggle'
import { Variables } from '../styles/Variables'

export const AccordionSectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 0;
    font-style: normal;
    letter-spacing: 0.0025em;
    color: ${Variables.color.pazola};
    font-family: ${Variables.font.title};
    font-weight: 300;
    font-size: 28px;
    line-height: 50px;

    ${media('<desktop')} {
        font-size: 16px;
        line-height: 50px;
    }

    ${(props) =>
        props.theme != '2' &&
        css`
            border-top: 1px solid ${Variables.color.pazolaGold};
            font-family: ${Variables.font.title};
        `}

    ${(props) =>
        props.theme == '2' &&
        css`
            font-weight: 500;
            font-size: 20px;
            letter-spacing: 0.0015em;
            padding: 28px 0;
        `}

    ${ToggleWrap} {
        svg {
            vertical-align: middle;
            width: 20px;
            path {
                stroke: ${Variables.color.pazolaGold};
            }
        }
    }
`

const SectionContent = styled.div`
    display: ${({ open }) => (open ? 'block' : 'none')};
    padding-top: 20px;
    padding-bottom: 20px;

    ${({ theme }) =>
        theme == '2' &&
        css`
            padding-top: 0;
            margin-top: -8px;
        `}
`

const ContentContainer = styled.div`
    /* overflow: hidden; */
`

export const SectionContainer = styled.div`
    ${(props) =>
        props.theme != '2' &&
        css`
            /* margin: 10px 0; */
        `}
`

const AccordionSection = ({ title, children, theme, defaultOpen }) => {
    const { [title]: isOpen, toggleSection } = useContext(AccordionContext)
    const toggleOpen = () => toggleSection(title)

    return (
        <SectionContainer theme={theme}>
            <AccordionSectionHeader open={isOpen} onClick={!defaultOpen ? toggleOpen : undefined} theme={theme}>
                {title}
                {!defaultOpen && <Toggle open={isOpen} />}
            </AccordionSectionHeader>
            <ContentContainer>
                <SectionContent open={isOpen} theme={theme}>
                    {children}
                </SectionContent>
            </ContentContainer>
        </SectionContainer>
    )
}

export default AccordionSection
